module.exports = __webpack_public_path__ + "img/maisonette-11.1a99851a.webp";